import { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { Loader2, FileText, ExternalLink } from "lucide-react";
import { openAuthFile } from "@/lib/files";

// Fase F — preview of an authenticated attachment (image inline, PDF as a card)
export default function AttachmentPreview({ url, className = "" }) {
  const [state, setState] = useState({ status: "loading" });

  useEffect(() => {
    let cancelled = false;
    if (!url) return undefined;
    setState({ status: "loading" });
    (async () => {
      try {
        const resp = await api.get(url.replace(/^\/api/, ""), { responseType: "blob" });
        if (cancelled) return;
        const type = resp.data.type || "";
        if (type.startsWith("image/")) {
          setState({ status: "image", objUrl: URL.createObjectURL(resp.data) });
        } else {
          setState({ status: "file", type });
        }
      } catch {
        if (!cancelled) setState({ status: "error" });
      }
    })();
    return () => {
      cancelled = true;
    };
  }, [url]);

  if (!url) return null;

  if (state.status === "loading") {
    return (
      <div className={`flex items-center justify-center bg-stone-100 rounded-lg h-40 ${className}`}>
        <Loader2 className="h-5 w-5 animate-spin text-stone-400" />
      </div>
    );
  }

  if (state.status === "image") {
    return (
      <img
        src={state.objUrl}
        alt="Anexo"
        onClick={() => openAuthFile(url)}
        className={`rounded-lg border border-stone-200 max-h-64 w-auto mx-auto cursor-zoom-in ${className}`}
        data-testid="attachment-preview-image"
      />
    );
  }

  return (
    <button
      type="button"
      onClick={() => openAuthFile(url)}
      className={`w-full flex items-center gap-3 border border-stone-200 rounded-lg px-4 py-3 bg-stone-50 hover:bg-stone-100 text-left ${className}`}
      data-testid="attachment-preview-file"
    >
      <FileText className="h-6 w-6 text-rose-600 shrink-0" />
      <div className="flex-1">
        <div className="font-display font-semibold text-sm">
          {state.status === "error" ? "Anexo" : "Documento PDF"}
        </div>
        <div className="text-xs text-stone-500 font-body">Toque para abrir em nova aba</div>
      </div>
      <ExternalLink className="h-4 w-4 text-stone-400" />
    </button>
  );
}
